import { FC, useMemo } from 'react';

import * as Yup from 'yup'
import {useFormik} from 'formik'

import { StatusErrorMessage, FormikNotesComponent } from '../../../../../components/widgets';
import { processNoteValues, doFormSubmit, reloadDraftVars } from '../../../../../components/helpers';
import { SubmitButtonComponent } from '../../../../../components/layout';
import { PhaseFormObserver } from '../../components/PhaseFormObserver';


const inspectionIssueSchema: any = Yup.object({
  reviewId: Yup.number().integer(),
  note: Yup.string().trim().required('Details required.').label('Notes'),
  noteAttachments: Yup.array().label('Supporting Documents'),
})

type Props = {
  reviewId: number
  draftVars: Record<string, any>
  doClose: Function
}

const InspectionIssueResponseForm : FC<Props> = ({ reviewId, draftVars, doClose }) => {

  const initValues = useMemo(() => {
    let initVals = {
      reviewId,
      note: '',
      noteAttachments: [],
    }

    reloadDraftVars(initVals, draftVars);

    return initVals;

  }, [reviewId, draftVars]);


  const formik = useFormik({
    initialValues: initValues,
    validationSchema: inspectionIssueSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: async (values, {setStatus, setSubmitting}) => {

      let payload = {
        reviewId,
      };

      processNoteValues(values, payload);
      
      await doFormSubmit('Phase_5_2Servlet', payload, setStatus, setSubmitting, () => {
        window.location.reload();
      });
    }
  })

  const doCancel = () => {
    doClose();
  }

  return (
  <>
  <PhaseFormObserver reviewId={reviewId} values={formik.values} isSubmitting={formik.isSubmitting} />
  <form id='kt_inspection_issue_response_form' className='form' onSubmit={formik.handleSubmit} noValidate>
    {/* begin::Scroll */}
    <div
      className='d-flex flex-column gap-4 mb-6 px-2'
      id='kt_inspection_issue_response_scroll'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-max-height='auto'
      data-kt-scroll-dependencies='#kt_inspection_issue_response_header'
      data-kt-scroll-wrappers='#kt_inspection_issue_response_scroll'
      data-kt-scroll-offset='300px'
    >
      <FormikNotesComponent formik={formik} attachLabel="Supporting Documents" required />

      <StatusErrorMessage status={formik.status} />
      <SubmitButtonComponent formik={formik} onCancel={doCancel} />
    </div>
  </form>
  </>
  )
}


export {InspectionIssueResponseForm}